/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import e from"./FeatureLikeLayerView.js";class r extends e{constructor(){super(...arguments),this.layer=null}}export{r as default};
